import './BrushsizePickerSlider.css'

const steepness = 8;

export function sliderValueToNormSize(value) {
    console.log(Math.pow(2, value * steepness) / Math.pow(2, steepness + 1))
    return Math.pow(2, value * steepness) / Math.pow(2, steepness + 1);
}

export function normSizeToSliderValue(normSize) {
    return Math.log2(Math.pow(2, steepness + 1) * normSize) / steepness;
}

export function BrushsizePickerSlider(props) {
    return (
        <div data-tip={props.dataTip} style={{ padding: '0px 1em 0px 1em' }}>
            <input type="range" min="0" max="1" step="0.01" value={normSizeToSliderValue(props.value)} onChange={e => props.valueUpdated(sliderValueToNormSize(e.target.valueAsNumber))} className="brushSizePickerSlider" />
        </div>
    );
}
